import { takeEvery, takeLeading } from 'redux-saga/effects'
import { all, call, put, select } from 'typed-redux-saga'

import ProductAPI from '@apis/branch/product'

import {
  ProductAction,
  setProductLoading,
  setProductSearchResult,
  SEARCH_PRODUCTS,
  SET_PRODUCT_DEFAULT,
  SET_PRODUCT_PAGINATION,
  SET_PRODUCT_SEARCH,
  SET_PRODUCT_PAGE_CONFIG,
  setProductPagination,
  searchProducts,
} from '@reducers/branch/product.reducer'
import { RootState } from '@reducers/index'
import { setStorageProduct } from '@reducers/storage.reducer'

function* searchProductSaga(action: ProductAction): Generator {
  if (action.type !== SEARCH_PRODUCTS) return
  const { hqId, branchId } = action.payload
  yield* put(setProductLoading(true))

  const search = yield* select((state: RootState) => state.product.search)
  const pagination = yield* select((state: RootState) => state.product.pagination)

  const {
    data: { products, total },
  } = yield* call(ProductAPI.getProducts, { hqId, branchId }, { ...search, ...pagination })

  yield* put(setProductSearchResult({ branchId, products, total }))

  yield* put(setProductLoading(false))
}

function* savePageConfigSaga(action: ProductAction): Generator {
  const state: Parameters<typeof setStorageProduct>[0] = {}

  if (action.type === SET_PRODUCT_PAGINATION) {
    const { pageSize } = action.payload.pagination
    state.pageSize = pageSize
  }

  yield* put(setStorageProduct(state))
}

function* setDefaultPageConfigSaga(action: ProductAction): Generator {
  if (action.type !== SET_PRODUCT_DEFAULT) return
  const { pageSize } = yield* select((state: RootState) => state.storage.productConfig)
  yield* all([put(setProductPagination({ pageSize }))])

  const { hqId, branchId } = action.payload
  yield* put(searchProducts(hqId, branchId))
}

export default function* authSaga(): Generator {
  yield* all([
    takeLeading(SEARCH_PRODUCTS, searchProductSaga),
    takeEvery(SET_PRODUCT_SEARCH, savePageConfigSaga),
    takeEvery(SET_PRODUCT_PAGINATION, savePageConfigSaga),
    takeEvery(SET_PRODUCT_PAGE_CONFIG, savePageConfigSaga),
    takeEvery(SET_PRODUCT_DEFAULT, setDefaultPageConfigSaga),
  ])
}
